import React, { useState } from 'react';
import Button from '@atlaskit/button';
import { InfoPanel } from '../..';
import './success-banner.scss';

interface SuccessBannerProps {
  email: string;
}

export const SuccessBanner = ({ email }: SuccessBannerProps) => {
  const [isVisible, setIsVisible] = useState(true);
  return isVisible ? (
    <div className="add-customer-success-banner" data-testid={`create-account-success-${email}`}>
      <InfoPanel
        type="success"
        message={
          <>
            <div>
              Created Atlassian account for <span className="fw-6">{email}</span>
            </div>
            <Button
              appearance="link"
              testId={`dismiss-${email}`}
              onClick={() => {
                setIsVisible(false);
              }}
              spacing="none"
            >
              Dismiss
            </Button>
          </>
        }
      ></InfoPanel>
    </div>
  ) : null;
};
